import { useEffect } from 'react'
import { BookingDetailPDF, DropdownOptionProps, TaskAssign } from '../new-contract-booking'
import { ModalNodeProps } from '../../../../components/modal.component'
import { Quote2ServiceDto, PaymentTerm, EmployeeModule } from '../../../../../definition'
import moment from 'moment'
import CompanyLogo from '../../../../../styles/images/left-nav/company-icon.png'
import { employeeLabel, getPaymentTermLlabel } from '../../../../../utils'
import { EMPLOYEE_MODULE } from '../../../../../constants/common.config'

export default function OneTimeBookingPDF(props: ModalNodeProps<BookingDetailPDF>) {
  useEffect(() => {
    setTimeout(() => {
      props.onClose && props.onClose()
    }, 5000)
  }, [])

  const getTechnicianName = (technicianId?: string, options?: DropdownOptionProps[]) => {
    const matchTech = options?.filter((option) => option.value === technicianId)
    if (matchTech && matchTech?.length > 0) {
      return matchTech[0].label
    } else {
      return ''
    }
  }

  const renderPaymentTermValueLabel = (paymentTerm: PaymentTerm) => {
    let label: string = ''
    switch (paymentTerm) {
      case PaymentTerm.CREDIT:
        label = 'Durations(Day)'
        break
      case PaymentTerm.PPP:
        label = 'Partial Payment Percentage (%)'
        break
      default:
        label = ''
    }
    return label
  }

  return (
    <div className='onetime-booking-detail-pdf'>
      <div className='company-information'>
        <div className='company-infor'>
          <div className='company-infor-detail'>
            <img src={props.input?.companyInfo?.logo || CompanyLogo} crossOrigin='anonymous' alt='company-logo' />
          </div>
        </div>
        <div className='company-infor'>
          <div className='company-infor-detail'>
            <div>
              <span>
                {props?.input?.companyInfo?.addressLine1}
                <br />
                {props?.input?.companyInfo?.addressLine2}
                <br />
                Singapore, {props?.input?.companyInfo?.postalCode}
              </span>
              <div>
                <span>Tel: </span>
                <span>{props?.input?.companyInfo?.tel}</span>
              </div>
              <div>
                <span>Email: </span>
                <span>{props?.input?.companyInfo?.email}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='general-infor'>
        <div>
          <label>Booking No.:</label>
          <p>{props.input?.booking?.code}</p>
        </div>
        <div>
          <label>Customer Name</label>
          <p>{props.input?.customerName}</p>
        </div>
        <div>
          <label>Contact Number</label>
          <p>{props.input?.customerContactNumber}</p>
        </div>
        <div>
          <label>Email</label>
          <p>{props.input?.customerEmail}</p>
        </div>
        <div>
          <label>Payment Terms</label>
          <p>{getPaymentTermLlabel(props.input?.paymentTerm)}</p>
        </div>
        {(props.input?.paymentTerm === PaymentTerm.CREDIT || props.input?.paymentTerm === PaymentTerm.PPP) && (
          <div>
            <label>{renderPaymentTermValueLabel(props.input?.paymentTerm)}:</label>
            <p>{props.input?.paymentTermValue}</p>
          </div>
        )}
      </div>
      <div className='services'>
        {props.input?.services?.map((service: Quote2ServiceDto, index: number) => {
          return (
            <div className='service-container'>
              <div className='service-index'>
                <label>Service</label>
              </div>
              <div className='service'>
                <div className='service-detail'>
                  <div className='no-border'>
                    <label>Service Name</label>
                    <div className='service-detail-field h-100'>{service.service?.name}</div>
                  </div>
                </div>
                <div className='service-detail'>
                  <div className='no-border'>
                    <label>Service Description</label>
                    <div className='service-detail-field h-100'>{service.service?.description}</div>
                  </div>
                </div>
                <div className='service-detail'>
                  <div>
                    <label>Notes</label>
                    <div className='service-detail-field h-100' style={{ whiteSpace: 'pre-line' }}>
                      {props.input?.notes}
                    </div>
                  </div>
                  <div>
                    <label>Discount( % )</label>
                    <div className='service-detail-field'>{service.discount}</div>
                  </div>
                </div>
                <div className='service-detail'>
                  <div>
                    <label>Quantity</label>
                    <div className='service-detail-field h-100'>{service.quantity}</div>
                  </div>
                  <div>
                    <label>Amount( $ )</label>
                    <div className='service-detail-field'>{service.amount}</div>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>
      <div className='appoinment'>
        <label className='appoinment-label'>Appointments Booked</label>
        {props.input?.bookedServices?.map((service, index) => {
          return (
            <div>
              <div className='times'>
                <label className='appoinment-service-label'>
                  Service {(props.input?.services || []).length > 1 ? `${index + 1}` : null}
                </label>
                <div className='technician-assign'>
                  {props.input?.tasks?.length &&
                    props.input?.tasks?.length > 0 &&
                    props.input?.bookingDto?.tasks
                      ?.filter((task) => task.service?.id === service.service?.id)
                      .map((task, index) => {
                        const startDate = task.timeSlotBeginAt ? moment(task.timeSlotBeginAt) : undefined
                        const endDate = task.timeSlotEndAt ? moment(task.timeSlotEndAt) : undefined
                        const tas: TaskAssign = {
                          id: task.id,
                          date: startDate ? startDate.toDate() : undefined,
                          timeSlotBegin: startDate ? startDate.format('hh:mmA') : undefined,
                          timeSlotEnd: endDate ? endDate.format('hh:mmA') : undefined,
                          assigneeId: task.assigneeId
                        }
                        let tsk = props.input?.tasks?.find((t) => t.id === task.id)
                        if (!tsk) {
                          props.input?.tasks?.push(tas)
                          tsk = tas
                        } else {
                          if (tsk.timeSlotBegin === undefined) {
                            tsk.timeSlotBegin = startDate ? startDate.format('hh : mmA') : undefined
                            tsk.timeSlotEnd = endDate ? endDate.format('hh : mmA') : undefined
                          }
                        }
                        return (
                          <div className='task'>
                            <div className='task-infor'>
                              <label>Service date</label>
                              <div className=''>
                                <p>{tsk.date ? moment(tsk.date).format('DD - MM - YYYY') : '--'}</p>
                              </div>
                            </div>
                            <div className='task-infor'>
                              <label>Time Slot</label>
                              <p>{tsk.date ? `${tsk?.timeSlotBegin} - ${tsk?.timeSlotEnd}` : '--'}</p>
                            </div>
                            <div className='task-infor'>
                              <label>{employeeLabel({ isFirstLetterUp: true })}</label>
                              <p>
                                {tsk.assigneeId
                                  ? getTechnicianName(
                                      EMPLOYEE_MODULE === EmployeeModule.Vendor ? tsk.companyId : tsk.assigneeId,
                                      props.input?.technicianOptions
                                    )
                                  : '--'}
                              </p>
                            </div>
                          </div>
                        )
                      })}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
